import React from "react";

export default function Projects ({data}) {
    return (
        <>
            <h1>{data.header} &nbsp;{data.emoji}</h1>
            <p className='gray'>{data.subheading}</p>
        </>
    );
}